import * as React from "react";
import { FileOverlay, Button } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

// A tiny inline SVG so the image preview needs no network (CSP-safe). Kept
// narrow/portrait-ish so the reviewer can confirm the controls hug the image,
// not the dialog's empty gutters.
const SAMPLE_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='320' height='460'><rect width='100%' height='100%' fill='%230A2540'/><text x='50%' y='50%' fill='%23fff' font-family='sans-serif' font-size='28' text-anchor='middle' dominant-baseline='middle'>preview.png</text></svg>",
  );

export function FileOverlayDemo() {
  const [imageOpen, setImageOpen] = React.useState(false);
  const [docOpen, setDocOpen] = React.useState(false);

  return (
    <Section
      id="file-overlay"
      title="FileOverlay"
      description="A full-screen preview lightbox for a chat attachment. Renders an image full-bleed, or a document as a labelled card. Built on the Dialog primitive, so it inherits focus-trap, Escape-to-close, scroll-lock, and the portal for free. Pass onDelete for the editable composer variant; omit it for the read-only sent variant. Controls bind to the media, not the dialog box: the close X sits at the top-right corner of the image / card, and download / delete sit in a centered bar directly below it."
    >
      <VariantBlock label="Image — composer variant" caption="onDelete present, so the editable file shows download + delete">
        <Button variant="outline" onClick={() => setImageOpen(true)}>
          Preview image
        </Button>
        <FileOverlay
          open={imageOpen}
          onOpenChange={setImageOpen}
          file={{ name: "preview.png", kind: "image", previewUrl: SAMPLE_IMAGE }}
          onDownload={() => {}}
          onDelete={() => {}}
        />
      </VariantBlock>

      <VariantBlock label="Document — sent variant" caption="no onDelete — a read-only preview with just download">
        <Button variant="outline" onClick={() => setDocOpen(true)}>
          Preview document
        </Button>
        <FileOverlay
          open={docOpen}
          onOpenChange={setDocOpen}
          file={{ name: "syllabus.pdf", kind: "document", sizeBytes: 48211 }}
          onDownload={() => {}}
        />
      </VariantBlock>
    </Section>
  );
}
